import moment from "moment";

/** Calendar-day key in local time. Empty when the value is missing. */
export function calendarDayKey(value) {
  if (!value) return "";
  const m = moment(value);
  return m.isValid() ? m.format("YYYY-MM-DD") : "";
}

/**
 * Inclusive day count. Monday through Monday is 8.
 * Matches BusChangeExtendService.IsInSelfEndWindow.
 */
export function inclusiveDaySpan(start, end) {
  const a = calendarDayKey(start);
  const b = calendarDayKey(end);
  if (!a || !b) return 0;
  return moment(b).diff(moment(a), "days") + 1;
}

/** Longer than 2 days and up to a week (3 through 7 calendar days). */
export function needsSelfEndChoice(start, end) {
  const span = inclusiveDaySpan(start, end);
  return span >= 3 && span <= 7;
}

export function datesDiffer(a, b) {
  return calendarDayKey(a) !== calendarDayKey(b);
}

export function formatSelfEndRange(start, end) {
  const span = inclusiveDaySpan(start, end);
  const from = calendarDayKey(start);
  const to = calendarDayKey(end);
  return {
    span,
    fromLabel: from ? moment(from).format("MM/DD/YYYY") : "",
    toLabel: to ? moment(to).format("MM/DD/YYYY") : "",
  };
}
